import metadata from '../../libphonenumber-js/metadata.min.json.esm.js';
import { createPhoneInput } from '../modules/PhoneInputWithCountryDefault.esm.js';
import isValidPhoneNumber$1 from '../../libphonenumber-js/es6/isValidPhoneNumber.esm.js';

function call(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments);
	args.push(metadata);
	return func.apply(this, args)
}

var ReactPhoneInput = createPhoneInput(metadata);

function isValidPhoneNumber() {
	return call(isValidPhoneNumber$1, arguments)
}

export { ReactPhoneInput as default, isValidPhoneNumber };
